module.exports = {
	"id": "CO",
	"name": "Colombia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.020271,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.020271,
			"19": null,
			"20": null,
			"21": 0.006757,
			"22": 0.094598,
			"23": 0.006757,
			"24": null,
			"25": 0.006757,
			"26": 0.047299,
			"27": 0.006757,
			"28": 0.006757,
			"29": 0.013514,
			"30": 0.013514,
			"31": 0.047299,
			"32": 0.020271,
			"33": 0.020271,
			"34": 0.040542,
			"35": 0.027028,
			"36": 0.027028,
			"37": 0.027028,
			"38": 0.047299,
			"39": 0.047299,
			"40": 0.040542,
			"41": 0.040542,
			"42": 0.040542,
			"43": 0.141897,
			"44": 0.114869,
			"45": 0.081084,
			"46": 0.141897,
			"47": 0.121626,
			"48": 0.148654,
			"49": 1.878446,
			"50": 0.27028,
			"51": 1.054092,
			"52": 0.790569,
			"53": 37.474322,
			"54": 10.824714,
			"55": 0.087841,
			"56": 0.013514,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.033785,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.006757,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.006757,
			"28": 0.006757,
			"29": null,
			"30": null,
			"31": 0.013514,
			"32": null,
			"33": null,
			"34": 0.006757,
			"35": 0.006757,
			"36": null,
			"37": 0.006757,
			"38": 0.027028,
			"39": 0.013514,
			"40": 0.013514,
			"41": 0.013514,
			"42": 0.013514,
			"43": 0.074327,
			"44": 0.027028,
			"45": 0.074327,
			"46": 0.054056,
			"47": 0.324336,
			"48": 0.27028,
			"49": 2.675772,
			"50": 0.033785,
			"51": 0.006757,
			"52": null,
			"3.5": null,
			"3.6": 0.013514
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.006757,
			"37": 0.020271,
			"38": 0.054056,
			"39": 0.006757,
			"40": 0.283794,
			"41": 0.054056,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.013514
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.006757,
			"6": null,
			"7": 0.027028,
			"8": 0.182439,
			"9": 0.216224,
			"10": 0.979765,
			"3.1": null,
			"3.2": null,
			"5.1": 0.027028,
			"6.1": 0.027028,
			"7.1": 0.006757,
			"9.1": 0.87841
		},
		"ios_saf": {
			"8": 0,
			"10": 1.69593238551,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.045703415383,
			"8.1-8.4": 0.0844351233347,
			"9.0-9.2": 0.0402809762698,
			"9.3": 0.6145430995
		},
		"android": {
			"3": 0,
			"4": 0.063996875969,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00799960949612,
			"4.1": 0.230845874031,
			"4.2-4.3": 0.577114685078,
			"4.4": 1.32336397093,
			"4.4.3-4.4.4": 1.3347919845
		},
		"ie": {
			"6": null,
			"7": 0.0139129372694,
			"8": 0.417388118081,
			"9": 0.146085841328,
			"10": 0.146085841328,
			"11": 1.16173026199,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0237064610003,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000658512805564
		},
		"edge": {
			"12": 0.060813,
			"13": 0.209467,
			"14": 0.391906
		},
		"ie_mob": {
			"10": 0.124695633803,
			"11": 0.507689366197
		},
		"bb": {
			"7": 0.05432025,
			"10": null
		},
		"samsung": {
			"0": 1.212882
		},
		"and_uc": {
			"0": 0.904797
		},
		"op_mini": {
			"0": 0.319393026194
		},
		"and_chr": {
			"0": 26.802201
		},
		"and_ff": {
			"0": 0.022701
		}
	},
	"total": 98.86593725
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CO.json
 ** module id = 499
 ** module chunks = 0
 **/